import { lazy } from 'react';

export const SettingsPage = lazy(() => import('./SettingsPage'));

